module.exports = __webpack_public_path__ + "static/media/bancolombia-icon_salary_003.6be9b146.svg";